import React from 'react'
import DOMPurify from 'dompurify';
import { sanitizeURLs } from 'utils/helpers';
import { allowedAttr, allowedTags } from 'constants/global';
const HTMLContent: React.FC<{ content: string }> = ({ content }) => {
    return (
        <div
            className={`content-wrapper mh-100`}
            style={{maxHeight: '100%'}}
        >
            <div
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                        sanitizeURLs(
                            typeof content === 'string'
                                ? content
                                : typeof content === 'object' && content !== null && 'text' in content
                                    ? (content as any).text ?? ''
                                    : ''
                        ), {ALLOWED_ATTR: allowedAttr, ALLOWED_TAGS: allowedTags}
                    ),
                }}
            />
        </div>
    )
}

export default HTMLContent